import React, { useEffect, useState } from 'react'
import Moment from 'react-moment'
import * as ReactBootstrap from 'react-bootstrap'
import { Slider } from '../../../../components'
import { GSXService } from '../../../../services'
import { Button } from 'react-bootstrap'

const DiagnosticsTestResult = (props) => {
  const { testResults } = props
  const getContextClass = (value) => {
    if (value < 0) {
      return 'table-warning'
    }
    if (value > 0) {
      return 'table-danger'
    }
  }
  return (
    <ReactBootstrap.Table>
      <thead>
        <tr>
          <th>Module</th>
          <th>Name</th>
          <th>Type</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {testResults.map((result) => {
          return (
            <tr className={getContextClass(result.testStatusCode)}>
              <td>{result.moduleName}</td>
              <td>{result.testName}</td>
              <td>{result.testType}</td>
              <td>
                {result.testStatus}({result.testStatusCode})
              </td>
            </tr>
          )
        })}
      </tbody>
    </ReactBootstrap.Table>
  )
}

const CustomerReport = ({ eventNumber }) => {
  const [url, setUrl] = useState()
  const get_diagnostics_customer_report_url = (event) => {
    new GSXService()
      .diagnostics_customer_report_url({
        event_number: event,
      })
      .then((response) => {
        setUrl(response.customerReportUrl)
      })
  }
  useEffect(() => {
    get_diagnostics_customer_report_url(eventNumber)
  }, [])
  return (
    <Button variant={'link'} href={url} target="_blank">
      Click me
    </Button>
  )
}

const DiagnosisReportGrid = (props) => {
  const { diagnostics } = props

  return (
    <ReactBootstrap.Table>
      <thead>
        <tr>
          <th>Suite</th>
          <th>Start Time</th>
          <th>End Time</th>
          <th>Customer Report</th>
          <th>Result</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {diagnostics &&
          diagnostics.map((result) => {
            return (
              <tr>
                <td>{result.context.suite}</td>
                <td>
                  <Moment fromNow>
                    {result.context.diagnosticStartTimeStamp}
                  </Moment>
                </td>
                <td>
                  <Moment fromNow>
                    {result.context.diagnosticEndTimeStamp}
                  </Moment>
                </td>
                <td>{result.context.localizedDiagnosticEventEndResult}</td>
                <td>
                  {result.context.isCustomerReportEligible ? (
                    <CustomerReport
                      eventNumber={result.context.diagnosticEventNumber}
                    />
                  ) : (
                    'N/A'
                  )}
                </td>
                <th>
                  <Slider
                    variant="light"
                    title="Results"
                    header={`Diagnosis Results for ${result.context.diagnosticEventNumber}`}
                  >
                    <DiagnosticsTestResult testResults={result.testResults} />
                  </Slider>
                </th>
              </tr>
            )
          })}
      </tbody>
    </ReactBootstrap.Table>
  )
}
export default DiagnosisReportGrid
